export default __webpack_public_path__ + "fc3343c864b69b0ee92bc40fc4e06960.webp";